export const String = {
  continue: "Continue",
  done: "Done",
  OnbordingStr: {
    title: "Plan Your Financial Future",
    subtitle:
      "Annual Client Review a Financial Planning tool to help you secure your financial future",
    GovtSubTitle: "GOVERNMENT RELGULATED  @@@",
    ButtonName: "Let’s Plan Your Finances",
    badgeText:
      "Your data is safe and secure. We don’t store it or share it with anyone.",
    DecryptedErrorMessage: "Decryption failed or resulted in empty text.",
    noDecryptedErrorMessage: "No encrypted data provided.",
    ERROR_MESSAGES: {
      length: "Mobile number must be 10 digits long.",
      invalid: "Mobile number is not valid.",
      server: "An error occurred while sending OTP.",
    },
    fourdigitErrorMessage: "OTP must be 4 digits long.",
    EnterOtp: "Please enter the OTP.",
    InvalidOTP: "Invalid OTP.",
    errorWhileVerifyOTP: "An error occurred while verifying OTP.",
    OTPresentsuccessfully: "OTP resent successfully",
  },
  OTPScreen: {
    Title: "Enter OTP",
    SubTitle: (timer) =>
      `We have sent OTP to your mobile number. It is valid for ${timer} minutes.`,
    ButtonResend: "Resend OTP",
    Authorize: "Verify",
    validOTPMessage: "Please enter a valid OTP before proceeding!",
    incorrectOTP: "OTP entered is incorrect. Please check.",
  },
  CurrentPortfolio: {
    CurrentPortfolioTitle: "Your Axis Max Life Portfolio",
    KnowyourPolicy: "Know your Policy",
    dragMessage:
      "Here’s a comprehensive overview of all your Axis Max Life Policies",
    failedToFetchData: "An error occurred while fetching data.",
    overview:
      "Here’s a comprehensive overview of all your policies linked to Axis Max Life",
    // The portfolio API returns no plan name or policy number, so both are
    // placeholders until those fields are added to /api/portfolio/fetch.
    planName: "Axis Max Life Term Plan",
    placeholderPolicyNumber: "123456789",
    perMonthSuffix: "/mon",
    yearsSuffix: "years",
    labels: {
      sumAssured: "Sum assured",
      premiumAmount: "Premium amount",
      policyTerm: "Policy Term",
      inceptionDate: "Policy Inception Date",
      totalPremiumPaid: "Total Premium Paid",
    },
    buttonText: "Proceed to income details",
  },
  Monthlyincome: {
    introduction: "Introduction",
    introductionScreenButton: "Let's get started",
    introductionSubTitle:
      "Hello! Let’s build your financial dashboard to help visualize your goals and track the progress. Let’s start with assessing your current financial preparedness",
    DragBarSLiderMessage:
      "Drag or input data to create your financial dashboard",
    ButtonName: "Let’s get started",
    Title: "Your Financial check-in",
    question1:
      "How much do you earn monthly, including other sources of income?",
    question2: "How much do you save in a month?",
    question3: "Select your investment style",
    investmentStyleTooltip:
      "Choose the approach that best matches how you prefer to invest.",
    amountPlaceholder: "Enter amount in ₹",
    proceedButton: "Proceed to future goals",
    investmentStyleAggressive:
      "Comfortable taking higher risks for potentially higher returns.",
    investmentStyleModerate: "Prefer a balanced mix of risk and steady growth.",
    investmentStyleConservative:
      "Prefer low-risk investments with stable, predictable returns.",
    ButtonAggressive: "Aggressive",
    ButtonConversion: "Conservative",
    ButtonModerate: "Moderate",
    incomePlaceholder: "Enter your monthly income",
    savingPlaceholder: "Enter your monthly savings",
    successMessage: "Financial details saved!",
    ERROR_MESSAGES: {
      errorWhileSaving:
        "An error occurred while saving financial details. Please try again.",
    },
  },
  Goal: {
    Title: "Your Financial check-in",
    selectGoalsHeading: "Select one or more goals you’d like to track",
    dragMessage: " Choose from goals below to track the progress",
    unknownGoalSelected: "Unknown goal selected",
    atleastGoalSelection: "Please select at least one goal.",
    goalSave: "Goals saved successfully!",
    erroWhileFetching: "An error occurred while fetching data.",
    DataFetchSuccessfully: "Data fetched successfully!",
  },
  ChildPlannig: {
    Title: "Your family",
    dragMessage: "The best time to start planning your child’s future is now!",
    question1: "Are you a parent?",
    question2: "Do you have any dependant?",
    question3: "How many children do you have?",
    childrenQuestion: "Do you have children?",
    childDetails: "Child details",
    dependentsDetails: "Dependents details",
    noDetailsFound: "No details found",
    addChild: "Add child",
    addDependant: "Add dependant",
    enterChildDetails: "Enter child details",
    enterDependentDetails: "Enter dependent details",
    selectDreamCourse: "Select the dream course",
    courseNamePlaceholder: "Course name",
    // {course} and {cost} are filled in from CoursesInitialValues.
    avgCostHint: "Avg cost of {course} in India is {cost} lakhs",
    saveDetails: "Save details",
    namePlaceholder: "Name",
    agePlaceholder: "Age",
    educationCost: "Education cost",
    educationFundsBy: "Education funds expected by (yrs)",
    weddingCost: "Wedding cost",
    weddingFundsBy: "Wedding funds expected by (yrs)",
    fundsNeededBy: "Funds needed by",
    addAnotherChild: "Add another child",
    addAnotherDependant: "Add another dependant",
    yearsSuffix: "yrs",
    deleteLabel: "Delete",
    editLabel: "Edit",
    childMessage: "Your 1st child’s name",
    childQuestion: "What is your child’s age?",
    validationMessageforchildanddependant:
      "Please fill in all fields for children and if dependants are there before continuing.",
    pleaseAllFeilds: "Please fill in all fields.",
    nameCannotEmpty: "Name cannot be a number.",
    dependantFeilds: " Please fill in all fields for each dependant.",
    includeDependant: "Include Dependants,",
    improveaccuracy: "Improve Accuracy",
  },
  ChildMarriageandEducation: {
    Screen1: {
      Title: "Your child’s future",
      dragMessage: "Drag or enter data to create your child’s future goals.",
      question1:
        "Can you estimate the approximate cost for child(s) education?",
      hint1:
        "Need help? Get suggestion for the average cost of different courses.",
      question2: "What is your estimated budget for child(s) wedding?",
      hint2: "Avg cost of marriage in India is 15-18 lakhs",
      addExpenseForEachChildButton: "+ Edit expense for each child",
    },
    Screen2: {
      buttomName1: "Engineering",
      buttomName2: "Medical",
      buttomName3: "Law",
      buttomName4: "Design",
      buttomName5: "MBA",
      buttomName6: "Others",

      hintTextMarriage: "Avg cost of marriage in India is 15-18 lakhs",
    },
    ChildEstimate: {
      yearQuestion1:
        "By when do you need the education funds for {child name} (years)",
      question2: "What is your estimated budget for child(s) wedding?",
      yearQuestion2:
        "By when do you need the wedding funds for {cgild name} ? (years)",
    },
  },
  Retirement: {
    dragMessage:
      "Ready to start planning for your future? Select your preference",
    SecondInning: {
      Title: "All About Your Golden Years",
      question1: "What does your ideal retirement look like?",
      selectGoal: "Please select any of goal",
      CardName: {
        c1: "Luxury Lifestyle",
        c2: `Maintain "\n" Status Quo`,
        c3: "Minimalist Lifestyle",
      },
      content:
        "A luxurious and indulgent retirement, enjoying the finer things in life without financial constraints.",
    },
    FutureGoal: {
      Title: "Future Goals",
      dragMessage:
        "Choose from options below to start planning for your future.",
      question1: "What are your other financial goals?",
      question2: "How much money do you need for your financial goals?",
      goalAmountPlaceholder: "Enter amount",
      question3: "When do you expect to need the funds?",
      goalAountYear: "Enter number of years",
      selectGoalerrorMessage: "Please select a goal!",
      goalAmountorNumberYear:
        "Please enter the goal amount or the number of years needed!",
      buttomName: {
        b1: "Car",
        b2: "Home",
        b3: "Business",
        b4: "Travel",
        b5: "Others",
      },
    },
  },
  AccountAggregator: {
    Title: "Just few more steps for Your financial dashboard!",
    dragMessage:
      "Connect your all accounts via government authorized portals and unlock your personalized financial dashboard.",
    imageMessage: "Connect your accounts in three simple steps",
    buttonName: "Connect all the accounts",
    EnterManuallyButton: "Enter Details Manually",
    chooseHeading: "Choose how you'd like to add your financial details.",
    fetchDigitallyTitle: "Fetch financial details digitally",
    fetchDigitallyDescription:
      "Connect your financial accounts through government-authorized portals, to pre-fill your income and investment details",
    linkAccountsButton: "Link Financial Accounts",
    enterManuallyButton: "Enter details manually",
    orSeparator: "Or",
    linkSteps: ["OTP Verification", "Link Accounts", "Consent & authorisation"],
    CibilScore: {
      Title: "Your Liabilities",
      dragMessage: "We will use the information to get your CIBIL details",
      labelName1: "Mobile Number",
      labelName2: "Full Name",
      labelName3: "PAN",
      cosentText:
        "I authorize Max Life to send this information via a private and secured service to fecth credit report and agree to Consent Terms, and Max Life Terms and Condition",
      buttonName: "Share CIBIL Details",
      otpScreenTitle: "Securely authorise your CIBIL Details",
      heading: "Thank You for Your Trust",
      content: "Your Personalised Financial Dashboard Awaits.",
    },
    shareAccount: "Share Account",
    faildOFetchDatainPolling: "Failed to fetch details. Please try again.",
  },
  Dashboard: {
    Title: "My Financial Snapshot",
    snapshotDragMessage:
      "Help us understand your finances better by entering the details below. Please fill the details carefully as it can be edited only once.",
    TotalAsset: "Total Asset",
    totalAssetToolTip:
      "Total value of everything owned by a person or business, including cash, property, etc.",
    MonthlyIncome: "Monthly Income",
    buttonName: "View Dashboard",
    mainDashboard: {
      heading: "Financial Wellness Advisory Dashboard",
      TotalAssets: "Total Assets",
      perannum: "per annum",
      Stock: "Stocks",
      Bank: "Bank",
      MtutalFund: "Mutual Fund",
      Deposit: "Deposit",
      EditDetails: "Edit Details",
      InsuranceEstimator: "Insurance Estimator",
      InsuranceTermlife: "Ideal Term life Insurance",
      LifeCoverage: "Current life Coverage",
      SavingGoals: "Saving Goals",
      Goalsareprioritisedbasedontheirtimesensitivity:
        "Goals are prioritised based on their time sensitivity. Only editable once.",
      GoalEditingAreyoySure: "Are you sure?",
      goalEditWarning:
        "Are you sure you want to edit? as edit is allowed only once",
      Alldataareindicative: "*All data are indicative ",
      TotalNetWorth: "Total Net Worth",
      MonthlySaving: "Monthly Saving",
      TotalLiabilities: " Total Liabilities",
      MonthlyEMIs: " Monthly EMIs",
      GoalPriority: "Goal Priority ",
      EditGoal: " Edit Goal",

      dashboardDataFetchSuccess: "Details fetched for dashboard.",
      dashboardDataFetchError: "Failed to fetch dashboard details.",
      completeYourJourneyFirstMessage: "Please complete your journey first.",
      dashboardDatasharewithpartnerMessage:
        "Dashboard shared with partner successfully.",
      buttonName: "Finish",
      bottamContent:
        "We’ll only share the necessary data to help you   achieve your financial goals. Your sensitive information, like bank & mutual funds details, will be kept private.",
      BankAmount: "Please enter Bank Amount",
      AvgExpenseAmount: "Please enter Avg Expenses Amount",
      PolicyAmount: "Please enter Policy Amount",
    },
    viewDashboard: "View Dashboard",
    expiredLink: "Please try again this link is expired",
    snapshot: {
      expensesAccordion: "Your expenses",
      investmentsAccordion: "Investments and savings",
      avgExpenses: "Avg expenses",
      loans: "Loans",
      emi: "EMI",
      savingBalance: "Balance in saving account",
      mutualFunds: "Mutual funds",
      stocks: "Stocks",
      totalLabel: "Total deposits",
      totalProvidentFund: "Total Maturity Amount",
      totalMaturityAmount: "Total Maturity Amount",
      totalPolicyCoverage: "Total coverage amount",
      totalNps: "Total NPS amount",
      addFund: "Add fund",
      addProvidentFund: "Add Fund",
      addPolicy: "Add Policy",
      addNps: "Add NPS",
      editFund: "Edit funds",
      editPolicy: "Edit Policies",
      editNps: "Edit NPS",
      addAnotherFund: "Add another fund",
      addAnotherPolicy: "Add another policy",
      modals: {
        deposit: {
          title: "Enter deposit details",
          listTitle: "Fund list",
          name: "Deposit name",
          amount: "Maturity amount",
          date: "Maturity date",
          save: "Save fund",
          summaryTitle: "Deposit",
          amountLabel: "Maturity amount",
          dateLabel: "Maturity date",
        },
        policy: {
          title: "Enter policy details",
          listTitle: "Policy List",
          type: "Select policy type",
          coverage: "Coverage amount",
          date: "Maturity date",
          premium: "Yearly premium",
          save: "Save policy",
          coverageLabel: "Coverage amount",
          premiumLabel: "Yearly premium",
          options: [
            { label: "Term Life", value: "Term Life" },
            { label: "Whole Life", value: "Whole Life" },
            { label: "ULIP", value: "ULIP" },
            { label: "Endowment", value: "Endowment" },
            { label: "Money Back", value: "Money Back" },
          ],
        },
        providentFund: {
          title: "Enter deposit details",
          listTitle: "Fund List",
          fundType: "Select account type",
          amount: "Total Amount",
          epfAmount: "EPF amount",
          ppfAmount: "PPF amount",
          maturityYear: "Maturity year",
          save: "Save fund",
          ppf: "PPF",
          epf: "EPF",
        },
        nps: {
          title: "Enter NPS details",
          holding: "Total holding",
          date: "Maturity date",
          save: "Save NPS",
        },
      },
      tooltips: {
        deposits: {
          title: "Deposits",
          body: "Includes Fixed Deposits (FDs), Recurring Deposits (RDs), Tax Saver Deposits, and other eligible bank deposits.",
        },
        providentFund: {
          title: "EPF/PPF",
          body: "Includes your EPF and PPF investments to give you a complete view of your retirement savings.",
        },
        policies: {
          title: "Policies",
          body: "Includes Term Life, Whole Life, ULIPs, and other eligible policies from insurers other than Axis Max Life.",
        },
        nps: {
          title: "NPS",
          body: "Includes your NPS investments to provide a complete view of your retirement savings.",
        },
      },
    },
    financialsnapshotFeilds: {
      totalDepositAmount: "totalDepositAmount",
      totalNpsAmount: "totalNpsAmount",
      providentFundAmount: "providentFundAmount",
      totalPolicyAmount: "totalPolicyAmount",
      totalBankBalanceAmount: "totalBankBalanceAmount",
      totalMutualFundsAmount: "totalMutualFundsAmount",
      totalStocksAmount: "totalStocksAmount",
      avgExpenses: "avgExpenses",
      loanAmount: "loanAmount",
      emiAmount: "emiAmount",
      totalAssetAmount: "totalAssetAmount",
      monthlyIncomeAmount: "monthlyIncomeAmount",
      totalPF: "totalPF",
      bankTitle: "Bank",
      depositTitle: "Deposits",
      policyTitle: "Policies",
      mutualfundTitle: "Mutual Funds",
      stocksTitile: "Stocks",
      ProvidentFundTitle: "Provident Fund",
      providentFundtitile: "Provident Fund",
      EMITitle: "EMI",
      npsTitle: "NPS",
      AvgExpensesTitle: "Avg Expenses",
      loanTitle: "Loans",
      availableBalance: "Available  Balance",
      totalBalace: "Total  Balance",
      totalCoverage: "Total  Coverage",
      totalAmount: "Total Amount",
      monthlyExpenses: "Monthly Expenses",
      monthlyEMI: "Monthly EMIs",
      totalLiabilities: "Total Liabilities",
    },
    Boxes: {
      Allfields: "All fields are required.",
      saveButton: "Save",
      deposit: {
        depositnameValidationMessage: "Deposit Name must contain only letters.",
        totalAmountValidationMessage: "Total Amount must be a valid number.",
      },
      policy: {
        totalAmountValidationMessage: "Total Amount must be a valid number.",
      },
      nps: {},
      profidant: {},
    },
    currentandtarget: {
      CurrentValue: "Current Value",
      TargetAmount: "Target Amount",
    },
    FinancialSnapshotMessages: {
      fetchDataFromServer: "Failed to fetch financial data from server.",
      accountDetailsFetchSuccessfully: "Account details fetch successfully",
      financialSnapshotSaveSuccess: "Financial snapshot saved successfully.",
      financialSnapshotSaveError: "Failed to save financial snapshot.",
      ErrorWhileSavingData:
        "An error occurred while saving financial snapshot.",
      EnterMissingPolicy: "Please enter missing policy details",
    },
    totolAMountCardTooltip: {
      TitleNetworth: "Total Net Worth",
      netWorthTitle:
        "The value of all assets owned minus all liabilities owed.",
      titleMonthlysaving: "Monthly Saving",
      monthlySavingTitle:
        "Portion of your income each month to build financial security and achieve your goals.",
      titleLiabalities: "Total Liabilities",
      totalLiabilitiesTitle:
        "The sum of all financial obligations a individual owes, including debts, loans, and other payables.",
      titlemontlhyEmI: "Monthly EMIs",
      monthlyEMITitle:
        "EMI is a fixed payment made each month towards repaying a loan, including both principal and interest.",
      MonthlyIncomeTitle: "Monthly Income",
      MonthlyIncomeTooltip:
        "Monthly Income is the total money a person or business earns in a month from all sources, such as salary, business profits, investments, or rentals.",
      agentdashboardTooltip:
        "Total value of everything owned by a person or business, including cash, property, etc.",
      loanTooltip:
        "Please do provide the outstanding loan amount if any, for more precise calculation!",
      emiTooltip:
        "Please do provide the EMI amount if any, for more precise calculation!",
    },
    erroeMessageforNotFetchData:
      "Failed to share dashboard with partner or Journey is already completed for user",
  },
  // Unit appended to a number-of-years field once it loses focus.
  yearsShort: "yrs",
  successMessageforGoalsave: "Goal saved successfully",
  successSeverity: "success",
  errorMessageforGoalsave:
    "An error occurred while saving goals. Please try again.",
  ErrorSeverity: "error",
  Cancel: "Cancel",
  Yes: "Yes",
  No: "No",
  Name: "name",
  Age: "age",
  FeedbackForm: {
    submitButton: "Submit Feedback",
    additionalFeedbackText: "Additional feedback",
    starRatingText: "/5 stars",
    shareexperienceBelowText: " Please rate your experience below",
    SessionFeedback: "Session Feedback",
    ErrorMessage: "Something went wrong please try again after sometime",
    SaveSuccessMessage: "Feedback saved successfully",
    feedbackPlaceholder: "Your feedback...",
  },
  navigations: {
    initiate: "/initiate",
    currentportfolio: "/currentportfolio",
    financialquestion: "/financialquestion",
    goal: "/goal",
    childquestion: "/childquestion",
    retirementgoal: "/retirementgoal",
    investmentgoal: "/investmentgoal",
    fetchinfo: "/fetchinfo",
    webview: "/webview",
    financialsnapshot: "/financialsnapshot",
    customerdashboard: "/customerdashboard",
    dashboard: "/dashboard",
  },
  journeyHeader: {
    title: "Plan Your Financial Future",
    backLabel: "Go back",
  },
  journeySteps: {
    incomeAndSavings: "Income & Savings",
    // Step 2 reuses Retirement.FutureGoal.Title ("Future Goals") in
    // JourneySteps.js, so it is deliberately not duplicated here.
    financialSnapshot: "Financial Snapshot",
    ariaLabel: "Plan your financial future progress",
  },
  gaEventName: {
    acrLogin: "acr_login",
    acrDashboard: "acr_dashboard",
    acrFeedback: "acr_feedback",
    acrPortfolio: "acr_portfolio",

    currentPortfolioEvent: "Current Portfolio Event",
  },
  gaEventClickName: {
    acrLoginLetsBegin: "acr_login_lets_begin",
    acrLoginAuthorise: "acr_login_authorise",
    acrLoginResendOtp: "acr_login_resend_otp",
    acrLoginAuthoriseFailed: "acr_login_authorise_failed",

    acrDashboardHome: "acr_dashboard_home",
    acrDashboardChildEducationView: "acr_dashboard_child_education_view",
    acrDashboardChildMarriageView: "acr_dashboard_child_marriage_view",
    acrDashboardFinish: "acr_dashboard_finish",

    acrFeedbackStars: "acr_feedback_stars",
    acrFeedbackSubmit: "acr_feedback_submit",

    acrPortfolioContinue: "acr_portfolio_continue",
    acrPortfolioLetsGetStarted: "acr_portfolio_lets_get_started",
    acrPortfolioIncomeEntered: "acr_portfolio_income_entered",
    acrPortfolioSavingsEntered: "acr_portfolio_savings_entered",
    acrPortfolioInvestmentStyleEntered:
      "acr_portfolio_investment_style_entered",

    acrPortfolioFinancialGoals: "acr_portfolio_financial_goals",
    acrPortfolioFinancialGoalsContinue:
      "acr_portfolio_financial_goals_continue",

    acrPortfolioParent: "acr_portfolio_parent",
    acrPortfolioParentContinue: "acr_portfolio_parent_continue",

    acrPortfolioChildren: "acr_portfolio_children",
    acrPortfolioChildrenContinue: "acr_portfolio_children_continue",

    acrPortfolioChildrenEducationAndMarriageContinue:
      "acr_portfolio_children_education_and_marriage_continue",

    acrPortfolioRetirementGoal: "acr_portfolio_retirement_goal",
    acrPortfolioRetirementGoalContinue:
      "acr_portfolio_retirement_goal_continue",

    acrPortfolioOtherFinancialGoals: "acr_portfolio_other_finacial_goals",
    acrPortfolioOtherFinancialGoalsContinue:
      "acr_portfolio_other_finacial_goals_continue",

    acrPortfolioFetchInfoConnectAllAccounts:
      "acr_portfolio_fetch_info_connect_all_accounts",
    acrPortfolioFetchInfoShareAccounts:
      "acr_portfolio_fetch_info_share_accounts",
    acrPortfolioFetchInfoSendOtp: "acr_portfolio_fetch_info_send_otp",
    acrPortfolioFetchInfoRegister: "acr_portfolio_fetch_info_register",
    acrPortfolioFetchInfoRegisterContinue:
      "acr_portfolio_fetch_info_register_continue",
    acrPortfolioFetchInfoRegisterContinueAuthorise:
      "acr_portfolio_fetch_info_register_continue_authorise",
    acrPortfolioFetchInfoManually: "acr_portfolio_fetch_info_manually",

    acrPortfolioFinancialSnapshotViewDashboard:
      "acr_portfolio_financial_snapshot_view_dashboard",

    currentPortfolioContinueClick: "Current Portfolio Continue Button",
  },
};
